import {
  enum_,
  type InferOutput,
  number,
  object,
  optional,
  string
} from 'valibot'

import { PACKAGE_CATEGORY_IMPORT_JOB_STATUS_TYPE } from '@/libs/api/types'

/**
 * 荷姿のインポート履歴の検索条件
 */
export const packageCategoryImportJobsSearchSchema = object({
  dcId: optional(number()),
  page: optional(number()),
  /** インポートステータス */
  status: optional(enum_(PACKAGE_CATEGORY_IMPORT_JOB_STATUS_TYPE)),
  /** ファイル名 */
  fileName: optional(string())
})

export type PackageCategoryImportJobsSearch = InferOutput<
  typeof packageCategoryImportJobsSearchSchema
>
